import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api/rawFetch'
import type { SizeNormRow } from '@/lib/api/session11Types'

export function useSizeNorm() {
  return useQuery({
    queryKey: ['size-normalization'] as const,
    queryFn: () => apiFetch<SizeNormRow[]>('GET', '/api/size-normalization/'),
    staleTime: 60_000,
  })
}

export function useSaveSizeNorm() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (rows: SizeNormRow[]) =>
      apiFetch<SizeNormRow[]>('PUT', '/api/size-normalization/', { body: rows }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['size-normalization'] }),
  })
}
